import React from "react";

import { isEnabled } from "utils/featureFlags";

import { Icon, Button } from "aible";

import giftIcon from "images/party-horn-light.svg";

import styles from "./style.module.css";

const WARNING_KEY = "aible_tableau_projects_warning";

export default class TableauProjectsWarning extends React.Component {
  constructor(props) {
    super(props);
    // props.removeItem(WARNING_KEY)

    const savedHidden = props.getItem(WARNING_KEY);

    this.state = {
      isHidden: Boolean(savedHidden),
      neverShow: false
    };
  }

  handleClose() {
    const { storeItem } = this.props;
    if (this.state.neverShow) {
      storeItem(WARNING_KEY, true);
    }
    return this.setState({ isHidden: true });
  }

  renderFooter() {
    return (
      <div className={styles.warningFooter + " " + styles.isDataReadinessWarning}>
        <input
          type="checkbox"
          style={{ marginBottom: "3px" }}
          checked={this.state.neverShow}
          onChange={() => {
            this.setState({ neverShow: !this.state.neverShow });
          }}
        />
        <div className={styles.warningFooterContent + " " + styles.isDataReadinessWarning}>
          {"Don't show this again."}
        </div>
        <Button onClick={() => this.handleClose()} className={styles.warningFooterButton}>
          {"Okay"}
        </Button>
      </div>
    );
  }

  render() {
    if (this.state.isHidden || !isEnabled("data-readiness-warning")) {
      return <React.Fragment />;
    }

    return (
      <div className={styles.warningWrapper + " " + styles.isTableauProjectsWarning}>
        <div className={styles.warning}>
          <div className={styles.warningHeader + " " + styles.isDataReadinessWarning}>
            <div className={styles.warningTitle + " " + styles.isDataReadinessWarning}>
              <span>{"Projects without an exploration have been hidden in Tableau."}</span>
            </div>
          </div>
          {this.renderFooter()}
        </div>
      </div>
    );
  }
}
